import JSBI from 'jsbi'

import { SolidityType } from '../constants'
import { validateSolidityTypeInstance } from '../utils'

import { ChainId } from '../constants'

/**
 * A currency is any fungible financial instrument on Ethereum, including Ether and all ERC20 tokens.
 *
 * The only instance of the base class `Currency` is Ether.
 */
export class Currency {
  public readonly decimals: number
  public readonly symbol?: string
  public readonly name?: string

  /**
   * The only instance of the base class `Currency`.
   */
  public static readonly ETHER: Currency = new Currency(18, 'ETH', 'Ether')

  public static readonly BNB: Currency = new Currency(18, 'BNB', 'BNB')
  public static readonly OKT: Currency = new Currency(18, 'OKT', 'OKT')
  public static readonly MATIC: Currency = new Currency(18, 'MATIC', 'MATIC')

  /**
   * Constructs an instance of the base class `Currency`. The only instance of the base class `Currency` is `Currency.ETHER`.
   * @param decimals decimals of the currency
   * @param symbol symbol of the currency
   * @param name of the currency
   */
  protected constructor(decimals: number, symbol?: string, name?: string) {
    validateSolidityTypeInstance(JSBI.BigInt(decimals), SolidityType.uint8)

    this.decimals = decimals
    this.symbol = symbol
    this.name = name
  }
}

const GAS_TOKENS: { [chainId in ChainId]?: Currency } = {
  [ChainId.OKEXCHAIN]: Currency.OKT,
  [ChainId.OKEXCHAIN_TESTNET]: Currency.OKT,
  [ChainId.MATIC]: Currency.MATIC,
  [ChainId.MATIC_MUMBAI]: Currency.MATIC,
  [ChainId.BSC]: Currency.BNB,
  [ChainId.BSC_TESTNET]: Currency.BNB,
  [ChainId.GÖRLI]: Currency.ETHER,
  [ChainId.MAINNET]: Currency.ETHER,
}

const ETHER = Currency.ETHER
export { ETHER, GAS_TOKENS }
